import {
	createTypes,
	createStaticAction,
	createAsyncAction,
} from '@flux';
import { mainStatusSelectorsPack } from '@status/selectors';


type ActionTypes = {
	FETCH_STATUS: string;
};

const types = createTypes<ActionTypes>([
	'FETCH_STATUS',
], 'STATUS');

const actions = {
	fetchStatus: createAsyncAction(types.FETCH_STATUS)(
		(box) => box.api.statusPack.security.directory.fetchStatus(),
		{
			cache: {
				asyncSelector: mainStatusSelectorsPack.selectAsyncStatus,
			},
		},
	) as () => void,
};

export const mainStatusActionsPack = {
	types,
	actions,
};
